import { IonButton, IonRow } from "@ionic/react"
import { useEffect } from "react"
import { useAppSelector } from "../../../Hooks"
import { selectUser } from "../../../reducers/UserReducer"
import { isStaff } from "../../extras/Functions"

interface props{
    page?:string
    setPage:any
}


const EnergyPerformanceMenu: React.FC<props>= ({page,setPage}) => {
    type Choices = 'home' | 'targets' | 'UtilityBills' | 'adjustments' | 'monthlyPerformance' | 'costAvoidanceData' | 'incentiveForecast' | 'annualTargets'
    const user = useAppSelector(selectUser)
    const handleMenuClick = (e:any,page:Choices) =>{
        setPage(page)
        const buttons: NodeListOf<Element>  = document.querySelectorAll(".energy-performance-menu-button")
        buttons.forEach((button:any)=>{
            button.classList.remove('selected')
        })
        e.target.classList.add('selected')

    }

    useEffect(()=>{
        const button = document.querySelector('#energy-performance-targets')
        button?.classList.add('selected')
    },[])


    return(
        <IonRow className="energy-performance-menu-buttons ion-justify-content-between" style={{borderBottom:"2px solid grey"}}>
            <div>
            {/* <IonButton className="energy-performance-menu-button" id="energy-performance-home" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'home')}>Energy Efficiency</IonButton> */}
            {/* <IonButton className="energy-performance-menu-button" id="monthlyPerformance" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'monthlyPerformance')}>Monthly Performance</IonButton> */}
            <IonButton className="energy-performance-menu-button" id="energy-performance-targets"  fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'targets')}>Monthly Energy Targets</IonButton>
            { isStaff(user) ? <IonButton className="energy-performance-menu-button" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'annualTargets')}>Annual Energy Targets</IonButton> : null }
            { isStaff(user) ? <IonButton className="energy-performance-menu-button" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'incentiveForecast')}>Incentive Forecast</IonButton> : null }
            {/* <IonButton className="energy-performance-menu-button" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'costAvoidance')}>Cost Avoidance</IonButton> */}
            <IonButton className="energy-performance-menu-button" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'UtilityBills')}>Utility Bills</IonButton>
            { isStaff(user) ? <IonButton className="energy-performance-menu-button" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'adjustments')}>Adjustments</IonButton> : null }
            { isStaff(user) ? <IonButton className="energy-performance-menu-button" fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'costAvoidanceData')}>Cost Avoidance</IonButton> : null }
            


            </div>
        </IonRow>
    )
}

export default EnergyPerformanceMenu